const DIALOG_CLASS = 'adobe-fonts-dialog';

const fetchDialogTemplate = async (templateId) => {
  const response = await fetch(`/shared/dialogs/${templateId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch dialog template: ${response.status} ${response.statusText}`);
  }
  return response.text();
};

/**
 * Attach a dialog to the page.
 * @param {string} templateId - The ID of the dialog template to fetch.
 * @returns {
 *  dialog: HTMLElement,
 *  dialogPromise: Promise<void>
 * } The dialog element and a promise that resolves when the dialog is closed.
 */
export const attachDialog = async (templateId) => {
  try {
    const template = await fetchDialogTemplate(templateId);
    const existingDialog = document.querySelector(`.${DIALOG_CLASS}`);
    if (existingDialog) {
      return {
        dialog: existingDialog,
        dialogPromise: Promise.resolve()
      };
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(template, 'text/html');
    const dialogContent = doc.body.firstElementChild;
    if (!dialogContent) {
      return {
        dialog: null,
        dialogPromise: Promise.reject(new Error('No dialog content found in template'))
      };
    }

    const spTheme = document.querySelector('sp-theme');

    const dialog = document.createElement('dialog');
    dialog.classList.add(DIALOG_CLASS);
    dialog.appendChild(dialogContent);

    // Create a Promise that resolves when the current dialog is closed
    const dialogPromise = new Promise((resolve) => {
      dialog.addEventListener('close', () => {
        dialog.remove();
        resolve();
      }, { once: true });
    });

    // Attach dialog within sp-theme to use spectrum css tokens
    spTheme.appendChild(dialog);
    dialog.showModal();

    return {
      dialog,
      dialogPromise
    };
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};

export const closeDialog = () => {
  const dialog = document.querySelector(`.${DIALOG_CLASS}`);
  dialog.close();
};
